export const expertList = [
  {
    "question": "What is your definition of “Data”?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Everything can be a datapoint! It's just information. The important part is to verify and critically evaluate the data as part of the interpretation and before acting on that information.",
    "author": "Haila",
    "career": "Director, UX Research",
    "company": ""
  },
  {
    "question": "Do you consider the word ”data” to be plural or singular?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "It's supposed to be plural but I use it as singular most of the time!",
    "author": "Edmond",
    "career": "Director, Data Science",
    "company": ""
  },
  {
    "question": "What is a large global problem that data helps to solve?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "As a data person, I want to say that it can help with all global problems, but the reality is that it’s not the data alone that solves a problem. It's people. Problems are solved by people collecting, analyzing, interpreting and thinking critically about data, and also being willing to listen to others' interpretations of the data.",
    "author": "Haila",
    "career": "Director, UX Research",
    "company": ""
  },
  {
    "question": "What does “data analysis” mean?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Data analysis is the conversion of raw information that has been collected into digestible insights that can help answer a question.",
    "author": "Andrew",
    "career": "VP, Client solutions",
    "company": ""
  },
  {
    "question": "What does “data analysis” mean?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Data analysis involves extracting information from data so that we can derive insights from it.",
    "author": "Mustafa",
    "career": "Data Scientist",
    "company": ""
  },
  {
    "question": "How do you use math skills in your daily work?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Data science is all about mathematics. It is important to understand statistical concepts to interpret and report results. Algebra forms the basis for almost all of the machine learning algorithms that are in use today, and to understand why a model is behaving the way it is, you need both algebra and statistics.",
    "author": "Mustafa",
    "career": "Data Scientist",
    "company": ""
  },
  {
    "question": "How do you use communication skills in your daily work?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Verbal and written communication skills are critical for sharing pertinent information with others in a way that they can understand it.",
    "author": "Susan",
    "career": "Member Representative",
    "company": ""
  },
  {
    "question": "Why is creativity important?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Creative problem solving is incredibly important for identifying problems to be solved, coming up with solutions and then testing the solutions.",
    "author": "Haila",
    "career": "Director, UX Research",
    "company": ""
  },
  {
    "question": "What are some ways that data is kept safe?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Files with personal data can be kept safe by controlling \"who\" can access the file; only give access to people with a valid reason to see or use the personal data. Always use a secure connection when working with personal data. And use wi-fi that is password protected when working with apps that access your personal data. ",
    "author": "LeeAnn",
    "career": "Process Manager, Privacy",
    "company": ""
  },
  {
    "question": "How can data help us understand our environment better?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Data collected around weather and climate patterns can help forecast potential inclement weather and allow countries and people to make the necessary preparations.",
    "author": "Andrew",
    "career": "VP, Client solutions",
    "company": ""
  },
  {
    "question": "How can people protect their personal data?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "When you are online, stop and think: “How would I feel if my family, boss, or college admissions person saw this?”. Sharing too much of your personal information might not always be best. Avoid posting any identity information that may allow a hacker to guess your security questions. Assume your posts will be available forever. Anything you post has the potential to be viewed, copied, forwarded or shared with anyone, not just your friends. Own your online presence and look after your personal data.",
    "author": "LeeAnn",
    "career": "Process Manager, Privacy",
    "company": ""
  },
  {
    "question": "What is your definition of “Data”?",
    "classroom": "",
    "school": "",
    "location": "",
    "answer": "Data is information that has been collected about a certain behavior or action but has not yet been analyzed.",
    "author": "Andrew",
    "career": "VP, Client solutions",
    "company": ""
  },
];
